export const zhDict = {
  'Account recovery requires verified contact information':
    '账户恢复需要验证过的联系方式',
  'Back to Sign In': '回到登录',
  'Change Password': '改变密码',
  Code: '确认码',
  Confirm: '确认',
  'Confirm a Code': '确认码',
  'Confirm Password': '确认密码',
  'Confirm Sign In': '确认登录',
  'Confirm Sign Up': '确认注册',
  Email: '邮箱',
  'Forgot Password': '忘记密码',
  'Incorrect username or password': '用户名或密码错误',
  'Invalid password format': '密码格式错误',
  'Invalid phone number format': '电话格式错误，请使用格式 +12345678900',
  'New Password': '新密码',
  or: '或者',
  Password: '密码',
  'Phone Number': '电话',
  'Resend a Code': '重发确认码',
  'Send Code': '发送确认码',
  'Sign In': '登录',
  'Sign Out': '退出',
  'Sign Up': '注册',
  Skip: '跳过',
  Submit: '提交',
  'User already exists': '用户已经存在',
  'User does not exist': '用户不存在',
  Username: '用户名',
  Verify: '验证',
  'Verify Contact': '验证联系方式',
};
